import apiClient from "../services/apiClient";
import { ATP_API_URL } from "../config/apiConfig";

export const fetchRequiredDocumentsAction = async (userId) => {
    try {
        if (!userId) {
            return {
                success: false,
                documents: [],
                error: "User ID is required",
            };
        }
        // console.log("User id ", userId);

        const response = await apiClient.get(`${ATP_API_URL.REQUIRED_DOCUMENTS}/${userId}`);
        // console.log("RESPONSE : ", response);
        if (response.status === 200 && response.data) {
            return {
                success: true,
                documents: response.data.documents || response.data.data,
                message: "Documents fetched successfully",
            };
        } else {
            return {
                success: false,
                documents: [],
                error: "Failed to fetch required documents",
            };
        }
    } catch (error) {
        return {
            success: false,
            documents: [],
            error: error.response?.data?.message || error.message || "Failed to fetch required documents",
        };
    }
};
